var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	32995: () => (loadSingletonVersion("default", "react", false, [1,17,0,2], () => (__webpack_require__.e(5043).then(() => (() => (__webpack_require__(65043))))))),
	26616: () => (loadStrictVersion("default", "axios", false, [2,0,25,0], () => (__webpack_require__.e(854).then(() => (() => (__webpack_require__(40854))))))),
	78145: () => (loadStrictVersion("default", "stellar-sdk", false, [1,10,1,2], () => (Promise.all([__webpack_require__.e(6382), __webpack_require__.e(504), __webpack_require__.e(1712), __webpack_require__.e(213), __webpack_require__.e(7384), __webpack_require__.e(1562), __webpack_require__.e(1734), __webpack_require__.e(7400), __webpack_require__.e(7207), __webpack_require__.e(8406), __webpack_require__.e(5408), __webpack_require__.e(3662)]).then(() => (() => (__webpack_require__(77400))))))),
	83024: () => (loadStrictVersion("default", "@reduxjs/toolkit", false, [1,1,7,2], () => (__webpack_require__.e(871).then(() => (() => (__webpack_require__(10871))))))),
	71695: () => (loadStrictVersion("default", "stellar-hd-wallet", false, [3,0,0,10], () => (Promise.all([__webpack_require__.e(6382), __webpack_require__.e(504), __webpack_require__.e(1712), __webpack_require__.e(213), __webpack_require__.e(7384), __webpack_require__.e(1562), __webpack_require__.e(1734), __webpack_require__.e(1781), __webpack_require__.e(8520), __webpack_require__.e(7160), __webpack_require__.e(7207), __webpack_require__.e(6782)]).then(() => (() => (__webpack_require__(77160))))))),
	60208: () => (loadStrictVersion("default", "@stellar/stellar-sdk", false, [4,14,0,0], () => (__webpack_require__.e(9121).then(() => (() => (__webpack_require__(49121))))))),
	46774: () => (loadStrictVersion("default", "@lobstrco/signer-extension-api", false, [1,1,0,0,,"beta",0], () => (__webpack_require__.e(7485).then(() => (() => (__webpack_require__(57485))))))),
	14185: () => (loadStrictVersion("default", "@creit.tech/stellar-wallets-kit", false, [1,1,9,5], () => (Promise.all([__webpack_require__.e(9011), __webpack_require__.e(8184), __webpack_require__.e(6392)]).then(() => (() => (__webpack_require__(99011))))))),
	97431: () => (loadStrictVersion("default", "@stellar/freighter-api", false, [1,1,4,0], () => (__webpack_require__.e(2922).then(() => (() => (__webpack_require__(32922))))))),
	86717: () => (loadSingletonVersion("default", "react-dom", false, [1,17,0,2], () => (__webpack_require__.e(7950).then(() => (() => (__webpack_require__(97950))))))),
	77207: () => (loadStrictVersion("default", "util", false, [2,0,12,4])),
	8946: () => (loadStrictVersion("default", "uri-template", false, [1,2,0,0], () => (__webpack_require__.e(8148).then(() => (() => (__webpack_require__(18148))))))),
	51665: () => (loadStrictVersion("default", "chart.js", false, [1,3,7,1], () => (__webpack_require__.e(1030).then(() => (() => (__webpack_require__(41030))))))),
	1740: () => (loadStrictVersion("default", "react-helmet-async", false, [1,2,0,4], () => (__webpack_require__.e(9367).then(() => (() => (__webpack_require__(49367))))))),
	20075: () => (loadStrictVersion("default", "@stellar-broker/client", false, [2,0,6,14], () => (__webpack_require__.e(5740).then(() => (() => (__webpack_require__(85740))))))),
	38457: () => (loadStrictVersion("default", "react-chartjs-2", false, [1,4,0,1], () => (__webpack_require__.e(2792).then(() => (() => (__webpack_require__(40411))))))),
	40289: () => (loadStrictVersion("default", "react-query", false, [1,3,34,16], () => (__webpack_require__.e(2907).then(() => (() => (__webpack_require__(82907))))))),
	45514: () => (loadStrictVersion("default", "color-thief-react", false, [1,2,1,0], () => (__webpack_require__.e(4892).then(() => (() => (__webpack_require__(24892))))))),
	47283: () => (loadStrictVersion("default", "react-spinners", false, [2,0,11,0], () => (__webpack_require__.e(3708).then(() => (() => (__webpack_require__(63708))))))),
	51594: () => (loadStrictVersion("default", "aws-amplify", false, [1,5,3,7], () => (Promise.all([__webpack_require__.e(213), __webpack_require__.e(9341), __webpack_require__.e(4032)]).then(() => (() => (__webpack_require__(9341))))))),
	62317: () => (loadStrictVersion("default", "moment", false, [1,2,29,1], () => (__webpack_require__.e(6178).then(() => (() => (__webpack_require__(86178))))))),
	65631: () => (loadStrictVersion("default", "react-scrollbars-custom", false, [1,4,1,1], () => (__webpack_require__.e(2459).then(() => (() => (__webpack_require__(2459))))))),
	68653: () => (loadStrictVersion("default", "react-google-recaptcha", false, [1,3,1,0], () => (__webpack_require__.e(8341).then(() => (() => (__webpack_require__(90722))))))),
	73449: () => (loadStrictVersion("default", "@fingerprintjs/fingerprintjs", false, [1,4,6,2], () => (__webpack_require__.e(1377).then(() => (() => (__webpack_require__(41377))))))),
	75031: () => (loadStrictVersion("default", "qrcode", false, [1,1,5,4], () => (__webpack_require__.e(8970).then(() => (() => (__webpack_require__(48970))))))),
	75722: () => (loadStrictVersion("default", "color-thief-ts", false, [1,1,1,1], () => (__webpack_require__.e(1481).then(() => (() => (__webpack_require__(31481))))))),
	78919: () => (loadStrictVersion("default", "react-redux", false, [1,7,2,6], () => (__webpack_require__.e(1537).then(() => (() => (__webpack_require__(21537))))))),
	88911: () => (loadStrictVersion("default", "reactjs-popup", false, [1,2,0,5], () => (__webpack_require__.e(5230).then(() => (() => (__webpack_require__(75230))))))),
	89731: () => (loadStrictVersion("default", "react-router-dom", false, [1,6,2,1], () => (__webpack_require__.e(3245).then(() => (() => (__webpack_require__(53245))))))),
	98184: () => (loadStrictVersion("default", "@stellar/freighter-api", false, [1,1,4,0], () => (__webpack_require__.e(5767).then(() => (() => (__webpack_require__(35767))))))),
	92224: () => (loadStrictVersion("default", "axios", false, [2,0,25,0], () => (__webpack_require__.e(2905).then(() => (() => (__webpack_require__(12905))))))),
	98486: () => (loadStrictVersion("default", "url", false, [2,0,11,0], () => (__webpack_require__.e(4648).then(() => (() => (__webpack_require__(64648))))))),
	82051: () => (loadStrictVersion("default", "url", false, [2,0,11,0], () => (__webpack_require__.e(1205).then(() => (() => (__webpack_require__(81205))))))),
	18540: () => (loadStrictVersion("default", "url", false, [2,0,11,0], () => (__webpack_require__.e(1122).then(() => (() => (__webpack_require__(31122))))))),
	18406: () => (loadStrictVersion("default", "util", false, [2,0,12,4], () => (Promise.all([__webpack_require__.e(1712), __webpack_require__.e(4113)]).then(() => (() => (__webpack_require__(86494))))))),
	65606: () => (loadStrictVersion("default", "sodium-native", false, [1,4,1,1], () => (Promise.all([__webpack_require__.e(3350), __webpack_require__.e(6626), __webpack_require__.e(8406), __webpack_require__.e(418)]).then(() => (() => (__webpack_require__(16626))))))),
	67451: () => (loadStrictVersion("default", "sodium-native", false, [1,4,1,1])),
	67006: () => (loadStrictVersion("default", "url", false, [2,0,11,0], () => (Promise.all([__webpack_require__.e(4080), __webpack_require__.e(253)]).then(() => (() => (__webpack_require__(74080))))))),
	32699: () => (loadStrictVersion("default", "web-vitals", false, [1,2,1,4], () => (__webpack_require__.e(6453).then(() => (() => (__webpack_require__(46453)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"208": [
		60208
	],
	"447": [
		14185,
		97431
	],
	"1695": [
		71695
	],
	"2382": [
		1740,
		20075,
		38457,
		40289,
		45514,
		47283,
		51594,
		62317,
		65631,
		68653,
		73449,
		75031,
		75722,
		78919,
		88911,
		89731
	],
	"2699": [
		32699
	],
	"2995": [
		32995
	],
	"3024": [
		83024
	],
	"4032": [
		92224,
		98486,
		82051,
		18540
	],
	"4046": [
		51665
	],
	"5408": [
		67451,
		67006
	],
	"6616": [
		26616
	],
	"6717": [
		86717
	],
	"6774": [
		46774
	],
	"6782": [
		65606
	],
	"7207": [
		77207
	],
	"8145": [
		78145
	],
	"8184": [
		98184
	],
	"8406": [
		18406
	],
	"8946": [
		8946
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}